





















import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import { useNewsletter } from '~/composables';
import JetInput from '../../atoms/Input/JetInput.vue';

export default defineComponent({
  name: 'CouponItem',
  components: {
    JetUiButton,
    JetInput,
    SvgImage,
  },
  setup() {
    const { updateSubscription, error, loading } = useNewsletter();
    const invalidEmail = ref(false);
    const email = ref('');

    const sendEmail = async () => {
      try {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
          invalidEmail.value = true;
        } else {
          await updateSubscription({ email: email.value });
          invalidEmail.value = false;
        }
      } catch {
        console.log(error);
      }
    };

    const showErrorMessage = computed(() => invalidEmail.value);

    return {
      email,
      showErrorMessage,
      sendEmail,
      loading,
    };
  },
});
